(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  class MotionPhoto extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.img = this.querySelector('img');
      if (!this.img) return;
      this.still = this.still || this.img.getAttribute('src');
      this.visible = false;
      this.update = () => {
        const mobileStage = matchMedia('(pointer: coarse), (max-width: 679px)').matches && this.closest('[data-sash-stage]');
        const next = !mobileStage && this.visible && !paused && !reduced.matches && !document.hidden && this.dataset.motion ? this.dataset.motion : this.still;
        if (this.img.getAttribute('src') !== next) this.img.setAttribute('src', next);
      };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
      this.observer.observe(this);
      document.addEventListener('sash:photo-motion', this.update);
      document.addEventListener('visibilitychange', this.update);
      reduced.addEventListener('change', this.update);
      // Run once after the element is fully connected so cached mobile
      // images do not remain on the still frame until the next scroll.
      requestAnimationFrame(this.update);
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.observer = null;
      document.removeEventListener('sash:photo-motion', this.update);
      document.removeEventListener('visibilitychange', this.update);
      reduced.removeEventListener('change', this.update);
    }
  }
  if (!customElements.get('sash-motion-photo')) customElements.define('sash-motion-photo', MotionPhoto);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-photo-pause]');
    if (!button) return;
    paused = !paused;
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? button.dataset.resume : button.dataset.pause;
    document.dispatchEvent(new Event('sash:photo-motion'));
  });
})();
